import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75bfbe82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FTLBidPayment" }
const _hoisted_2 = { class: "FTLBidPayment__container" }
const _hoisted_3 = { class: "container__block" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block__title" }, "Себестоимость", -1))
const _hoisted_5 = { class: "block__content" }
const _hoisted_6 = { class: "block__field" }
const _hoisted_7 = { class: "field__placeholder" }
const _hoisted_8 = { class: "field__value" }
const _hoisted_9 = { class: "block__field" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Способ оплаты", -1))
const _hoisted_11 = { class: "field__value" }
const _hoisted_12 = { class: "container__block" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block__title" }, "Выставление", -1))
const _hoisted_14 = { class: "block__content" }
const _hoisted_15 = { class: "block__field" }
const _hoisted_16 = { class: "field__placeholder" }
const _hoisted_17 = { class: "field__value" }
const _hoisted_18 = { class: "block__field" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Предоплата", -1))
const _hoisted_20 = { class: "field__value" }
const _hoisted_21 = {
  key: 0,
  class: "container__block"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block__title" }, "Таможенное оформление", -1))
const _hoisted_23 = { class: "block__content" }
const _hoisted_24 = { class: "block__field" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Инвойс", -1))
const _hoisted_26 = { class: "field__value" }
const _hoisted_27 = {
  key: 0,
  class: "block__field"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Документ", -1))
const _hoisted_29 = { class: "field__value" }
const _hoisted_30 = ["href"]
const _hoisted_31 = {
  key: 1,
  class: "block__field"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Стоимость инвойса", -1))
const _hoisted_33 = { class: "field__value" }
const _hoisted_34 = { class: "block__field" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Упаковочный лист", -1))
const _hoisted_36 = { class: "field__value" }
const _hoisted_37 = { class: "block__field" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Оформить импорт", -1))
const _hoisted_39 = { class: "field__value" }
const _hoisted_40 = { class: "block__field" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Оформить экспорт", -1))
const _hoisted_42 = { class: "field__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.costTitle), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.costPriceValue), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.paymentMethodName || '-'), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.paidPriceTitle), 1),
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.formatAmount(_ctx.paidPrice)), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              (_ctx.isPrepayment)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("Да")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Нет")
                  ], 64))
            ])
          ])
        ])
      ]),
      (_ctx.customPayment)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  (_ctx.customPayment.is_invoice)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("Да")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("Нет")
                      ], 64))
                ])
              ]),
              (_ctx.customPayment.is_invoice)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("a", {
                        class: "text-blue-500 underline",
                        target: "_blank",
                        href: _ctx.customPayment.document_path
                      }, "Скачать", 8, _hoisted_30)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.invoiceCost) + " " + _toDisplayString(_ctx.invoiceName), 1)
                  ])),
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("div", _hoisted_36, [
                  (_ctx.customPayment.is_packing_list)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("Да")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("Нет")
                      ], 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, [
                  (_ctx.customPayment.is_arrange_import)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("Да")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("Нет")
                      ], 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("div", _hoisted_42, [
                  (_ctx.customPayment.is_arrange_export)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("Да")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("Нет")
                      ], 64))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}